import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { OrderPreparationApiAdapter } from '../adapters/OrderPreparationApiAdapter';
import { Filters } from '../models/OrderPreparation';
import { Service } from '../services/Service';

export const useOrderPreparation = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new OrderPreparationApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['orderpreparation', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 2 * 60 * 1000, // 2 minutos - datos frescos
    // 🎯 En React Query v5, usamos placeholderData para mantener los datos anteriores
    placeholderData: (previousData) => previousData,
  });

  const orderpreparation = data?.pages.flatMap((page) => page.orderpreparation) ?? [];


  // Obtener el total del API (siempre sera el mismo en todas las paginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    orderpreparation,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    // Nuevas props para scroll infinito
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    // Stats útiles
    totalPages: data?.pages.length ?? 0,
    totalPreparations: orderpreparation.length,
    total: totalFromApi, // Total real del API (con filtros)
  };
};
